import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDogNoCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M20.0046 12.1531L18.2905 9.65533C18.1635 9.4706 17.9946 9.31906 17.7979 9.21328C17.6013 9.1075 17.3824 9.05053 17.1596 9.04708L13.9067 9H13.9C12.2206 9 10.9321 9.28337 10.1022 10.6663C9.32958 11.9536 9 14.1465 9 17.9985V18.4693H10.0662L9.37987 22H10.331L11.0174 18.4693H11.3333C12.0955 18.4761 12.8298 18.1803 13.3776 17.6457C13.8728 17.1677 14.23 16.5137 14.4106 15.7546L14.4123 15.7477L15.2127 11.8786H14.2592L13.5015 15.5414C13.2707 16.5029 12.5807 17.5277 11.3333 17.5277H9.93508C9.96043 14.1951 10.2612 12.2193 10.9006 11.1538C11.4373 10.2593 12.2218 9.94182 13.8968 9.94138L17.1462 9.98846C17.2205 9.9896 17.2934 10.0086 17.359 10.0438C17.4245 10.0791 17.4808 10.1296 17.5231 10.1912L19.4621 13.0164L22.0667 13.4543V13.9533L21.6323 16.29C21.5041 16.9797 21.285 17.3272 20.3864 17.4361L16.7025 18.0719L16.6781 22H17.6114L17.6309 18.8667L20.5096 18.3694C21.1618 18.2886 21.643 18.0765 21.9804 17.7215C22.2689 17.4179 22.4444 17.03 22.5497 16.4636L23 14.0408V12.6567L20.0046 12.1531Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgDogNoCircle);
export { ForwardRef as ReactComponent };
